// extracted by mini-css-extract-plugin
module.exports = {"root":"HomepageTopInjectorMobile_root__3YBDX"};